export const interactionTypes = {
    OPEN_WIDGET_DETAILS: 'OPEN_WIDGET_DETAILS',
    OPEN_PROFILE: 'OPEN_PROFILE',
    PUSH_PROFILE: 'PUSH_PROFILE',
    CHANGE_PROFILE_INDEX: 'CHANGE_PROFILE_INDEX',
    TOGGLE_PROFILE_EDIT: 'TOGGLE_PROFILE_EDIT',
    CLOSE_WIDGET_DETAILS: 'CLOSE_WIDGET_DETAILS',
    SET_TRENDLINES: 'SET_TRENDLINES',
}
